import { client_v2 } from "utils/api";

const getBrandLabels = (q) =>
  new Promise(async (resolve, reject) => {
    try {
      const { data } = await client_v2.get(
        `/brand_labels?context=list&per_page=200&sort[column]=name&sort[order]=asc${
          q ? `&q[name_matches]=%25${q}%25` : ""
        }`,
      );
      resolve(
        data.map(({ id, name }) => ({
          label: name,
          value: id,
        })),
      );
    } catch (error) {
      reject(error);
    }
  });

export default getBrandLabels;
